import { Text } from "../../Type";
import OpenCard from "../../OpenCard";
import InfoCard from "../../InfoCard";
import OrganizationCard from "../../OrganizationCard";
import LocationCard from "../../LocationCard";
import { UserType } from "../../../types/userType";
import styles from "./index.module.scss";
import { isAdmin, isAuthorizer, isSalesRep } from "../../../utils/user";

const UserProfile = ({ user }: { user: UserType }) => {
  return (
    <div className={styles.profile}>
      <InfoCard
        title="Contact Information"
        sections={[
          {
            content: [
              {
                label: "Email",
                value: user.email || "-",
              },
              {
                label: "Phone",
                value: user.phone ? `${user.phone}${user.phone_ext ? ` x${user.phone_ext}` : ""}` : "-"
              },
            ],
          },
        ]}
      />

      {!isAdmin(user) && (
        <OpenCard
          title={
            isAuthorizer(user) ? "Professional Organization" : "Motion Location"
          }
        >
          {isAuthorizer(user) && user.organization && (
            <div className={styles.orgCard}>
              <OrganizationCard organization={user.organization} />
            </div>
          )}
          {isSalesRep(user) && (
            <div className={styles.orgCard}>
              {user.locations.map((loc) => {
                return (
                  <div className={styles.locationCardMargin}>
                    <LocationCard key={loc.id} location={loc} />
                  </div>
                );
              })}
            </div>
          )}
          {isAuthorizer(user) && (
            <div className={styles.orgText}>
              <Text className={styles.orgAuthLabel}>ADP Authorizer Number</Text>
              <Text className={styles.orgAuthNum}>
                {user.adp_auth_num || "-"}
              </Text>
            </div>
          )}
        </OpenCard>
      )}
    </div>
  );
};

export default UserProfile;
